import MESSAGES from "../../../../../../../../../appMessages";

export const validateExceptionDetail = (name, value) => {
  if (name === "adeNumber") {
    const adeNumberToString = value + "";
    if (!adeNumberToString) {
      return MESSAGES.PROCESS_DELIVERY.ADE_REQUIRED;
    } else if (
      !(adeNumberToString.length >= 7 && adeNumberToString.length <= 9)
    ) {
      return MESSAGES.PROCESS_DELIVERY.INVALID_ADE_LENGTH;
    }
  }
  return null;
};

export const getDefaultExceptionDetail = () => {
  return {
    adeNumber: null,
  };
};

export const getExceptionDetail = (editInfo) => {
  return {
    adeNumber: editInfo.adeNumber,
  };
};

export const exceptionDetailFields = ["adeNumber"];
